import { Box, Skeleton } from '@mui/material';
import useSelectorTyped from 'store/useSelectorTyped';
import NursingRecord from './NursingRecord';
import MedicalNote from './MedicalNote';

interface Props {
  coachRef: any;
}

const Content = (props: Props) => {
  const { coachRef } = props;
  const patientInfo = useSelectorTyped(state => state.patient.patientInfo);

  const contentBoxSx = {
    display: 'flex',
    flexDirection: { xs: 'column', lg: 'row' },
    mt: 2.5,
    columnGap: 2.5,
    rowGap: { xs: 2.5, lg: 0 },
    overflow: { xs: 'visible', lg: 'hidden' },
    height: { xs: 'auto', lg: 'calc(100% - 180px)' },
    minHeight: { xs: 360, lg: 0 },
  };

  if (!patientInfo) {
    return (
      <Box sx={contentBoxSx}>
        <Box flex={1} display="flex" flexDirection="column" overflow="auto">
          <Skeleton variant="rectangular" sx={{ flex: 1 }} />
        </Box>
        <Box
          ref={coachRef}
          flex={1}
          display="flex"
          flexDirection="column"
          overflow="auto"
        >
          <Skeleton variant="rectangular" sx={{ flex: 1 }} />
        </Box>
      </Box>
    );
  }

  return (
    <Box sx={contentBoxSx}>
      <MedicalNote patientInfo={patientInfo} />
      <NursingRecord patientInfo={patientInfo} coachRef={coachRef} />
    </Box>
  );
};

export default Content;
